import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { SUCCESS_URL } from 'Route/Checkout/Checkout.config';
import history from 'Util/History';

import PromotionsTopBlock from './PromotionsTopBlock.component';
/** @namespace Bodypwa/Component/PromotionsTopBlock/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    isCheckout: state.CheckoutReducer.isCheckout
});

/** @namespace Bodypwa/Component/PromotionsTopBlock/Container/mapDispatchToProps */
export const mapDispatchToProps = () => ({
});
/** @namespace Bodypwa/Component/PromotionsTopBlock/Container */
export class PromotionsTopBlockContainer extends PureComponent {
    static propTypes = {
        isCheckout: PropTypes.bool.isRequired
    };

    state = {
        isHomePage: false,
        isSuccess: false
    };

    componentDidMount() {
        const { location: { pathname } = {} } = history;
        this.setState({ isHomePage: pathname === '/', isSuccess: pathname.includes(SUCCESS_URL) });
    }

    componentDidUpdate() {
        const { location: { pathname } = {} } = history;
        const { isHomePage: isHomePageState, isSuccess: isSuccessState } = this.state;
        const isHomePage = pathname === '/';
        const isSuccess = pathname.includes(SUCCESS_URL);
        if (isHomePage !== isHomePageState) {
            this.setState({ isHomePage });
        }
        if (isSuccessState !== isSuccess) {
            this.setState({ isSuccess });
        }
    }

    containerProps = () => {
        const { isCheckout } = this.props;
        const { isHomePage, isSuccess } = this.state;
        return {
            isCheckout,
            isHomePage,
            isSuccess
        };
    };

    render() {
        return (
            <PromotionsTopBlock
              { ...this.containerFunctions }
              { ...this.containerProps() }
            />
        );
    }
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(PromotionsTopBlockContainer)
);
